<div class="flex items-center justify-center dialog-header">
  {{ type }} Active Directory Configuration
  <div class="absolute right-2">
    <button (click)="handleCloseDialog()" class="outline-none p-5">
      <i class="pi pi-times"></i>
    </button>
  </div>
</div>

<div class="dialog-content">
  <form [formGroup]="outlookForm" (ngSubmit)="submitForm()" class="p-fluid grid grid-cols-2 gap-6">

    <div class="flex flex-col">
      <label class="mb-2 font-semibold">App Client ID *</label>
      <input pInputText formControlName="app_client_id"
             class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500"/>
      <div *ngIf="outlookForm.get('app_client_id')?.invalid && (outlookForm.get('app_client_id')?.touched || submitted)"
           class="text-red-500 text-xs mt-1">App Client ID is required.</div>
    </div>

  
    <div class="flex flex-col">
      <label class="mb-2 font-semibold">Client Secret *</label>
      <input pInputText formControlName="client_secret" type="password"
             class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500"/>
      <div *ngIf="outlookForm.get('client_secret')?.invalid && (outlookForm.get('client_secret')?.touched || submitted)"
           class="text-red-500 text-xs mt-1">Client Secret is required.</div>
    </div>

    <div class="flex flex-col">
      <label class="mb-2 font-semibold">Grant Type *</label>
      <input pInputText formControlName="grant_type"
             class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500"/>
      <div *ngIf="outlookForm.get('grant_type')?.invalid && (outlookForm.get('grant_type')?.touched || submitted)"
           class="text-red-500 text-xs mt-1">Grant Type is required.</div>
    </div>

    <div class="flex flex-col">
      <label class="mb-2 font-semibold">Tenant ID *</label>
      <input pInputText formControlName="tenant_id"
             class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500"/>
      <div *ngIf="outlookForm.get('tenant_id')?.invalid && (outlookForm.get('tenant_id')?.touched || submitted)"
           class="text-red-500 text-xs mt-1">Tenant ID is required.</div>
    </div>

    <div class="flex flex-col">
      <label class="mb-2 font-semibold">Scope *</label>
      <input pInputText formControlName="scope"
             class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500"/>
      <div *ngIf="outlookForm.get('scope')?.invalid && (outlookForm.get('scope')?.touched || submitted)"
           class="text-red-500 text-xs mt-1">Scope is required.</div>
    </div>

    <div class="flex flex-col col-span-2">
      <label class="mb-2 font-semibold">Redirect URL *</label>
      <input pInputText formControlName="redirect_uri"
             class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500"/>
      <div *ngIf="outlookForm.get('redirect_uri')?.invalid && (outlookForm.get('redirect_uri')?.touched || submitted)"
           class="text-red-500 text-xs mt-1">Redirect URL is required.</div>
    </div>

    <div class="col-span-2 flex justify-end mt-2">
      <p-button label="Submit" type="submit" [loading]="isLoading" icon="pi pi-check" class="w-full"
                [disabled]="outlookForm.invalid || isLoading"></p-button>
    </div>

  </form>
</div>
